import Box from '@mui/material/Box';
import React from 'react';
import { captureError } from '../utils/capture-error';
import { AllianceErrorBoundary } from './alliance/error-boundary';
import { SectionErrorScreen } from './alliance/system-screens';

/**
 * Wraps one section (a tab, a drawer, the map) so a render error there shows
 * the compact "This section didn't load." with Try again, and the rest of
 * the page keeps working.
 *
 * @param dense - Inside a drawer
 */
export function SectionErrorBoundary(props: {
  children: React.ReactNode;
  dense?: boolean;
}) {
  return (
    <AllianceErrorBoundary
      onError={(error, errorInfo) =>
        captureError({ data: { error, errorInfo } })
      }
      fallback={({ reset }) => (
        <Box sx={{ p: 2 }}>
          <SectionErrorScreen onRetry={reset} dense={props.dense} />
        </Box>
      )}
    >
      {props.children}
    </AllianceErrorBoundary>
  );
}
